<template>
  <GrayBlockContainer>
    <TitleWithSwitch :toggle.sync="syncEnabled" :inactiveText="inactiveText">
      <template #title>
        <div class="flex items-center gap-[8px]">
          <p class="text-primary-100 font-bold text-normal" style="line-height: 23.17px;">{{ title }}</p>
          <span class="ai-tag" data-testid="upsell-ai-tag">AI</span>
        </div>
      </template>
    </TitleWithSwitch>

    <div class="hint-box">
      <p>{{ displayText.hint }}</p>
      <p v-for="rule in displayText.rules" :key="rule">・{{ rule }}</p>
    </div>

    <a
      v-if="showPairingSettingLink"
      :href="pairingSettingHref"
      target="_blank"
      class="pairing-setting-link"
      data-testid="upsell-pairing-setting-link"
    >
      {{ displayText.pairingSettingLink }} &gt;
    </a>
  </GrayBlockContainer>
</template>

<script>
import { computed, defineComponent } from 'vue'
import { useVModel } from '@vueuse/core'
import { useRouter } from 'vue-router/composables'
import GrayBlockContainer from '@/components/Container/GrayBlockContainer.vue'
import TitleWithSwitch from '@/components/TitleWithSwitch.vue'
import { usePermissions } from '@/use/permissions'

// CNCY-10769 推薦加購卡牌：不套用範本，內容由推薦加購 AI Agent 產生
export default defineComponent({
  name: 'UpsellRecommendationBlock',
  components: { GrayBlockContainer, TitleWithSwitch },
  props: {
    title: String,
    inactiveText: String,
    enabled: Boolean,
  },
  setup (props, { emit }) {
    const router = useRouter()
    const { checkAction } = usePermissions()
    const syncEnabled = useVModel(props, 'enabled', emit)

    const displayText = {
      hint: '此卡牌內容由推薦加購 AI Agent 依本次預約資訊、會員與店家歷史紀錄自動產生，無法套用範本。',
      rules: [
        '每次推薦 1～2 項服務項目或附加服務，不會重複推薦本次預約已包含的服務',
        '無合適推薦時不發送此卡牌，不影響其他通知內容',
        '會員點擊「我有興趣，到店詢問」後，系統將加購意向寫入該筆預約備註，不修改原預約時間、服務與金額',
      ],
      pairingSettingLink: '前往設定推薦服務搭配',
    }

    const showPairingSettingLink = computed(() => checkAction('admin.appointmentServicePairing.page'))
    // 另開分頁，避免離開時未儲存的通知設定遺失
    const pairingSettingHref = computed(() => router.resolve({ name: 'AppointmentServicePairingSetting' }).href)

    return { syncEnabled, displayText, showPairingSettingLink, pairingSettingHref }
  },
})
</script>

<style lang="postcss" scoped>
.ai-tag {
  @apply bg-primary-100 text-white text-sm leading-[16px] font-medium;
  @apply px-[4px] rounded-[2px];
}

.hint-box {
  @apply bg-white border border-gray-40 rounded-[4px];
  @apply text-gray-80 text-sub leading-[24px];
  @apply px-[12px] py-[8px];
}

.pairing-setting-link {
  @apply inline-block mt-[12px] text-primary-100 text-sub underline cursor-pointer;
}
</style>
